import React from "react";
import SEO from "@/components/SEO";
import { useContent } from "@/context/ContentContext";
import { Mail, Phone, MapPin, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const DEFAULT_FORM_URL = "https://eu.forms.app/blue1media/contact-form-1-1";

export default function Contact() {
  const { c } = useContent();
  const formUrl = c("contact_form_url", DEFAULT_FORM_URL);

  return (
    <>
      <SEO title="Contact" path="/contact" description="Neem contact op met VoiceOverKids — internationaal kinderstemcastingbureau & opnamestudio in Leiden, Nederland." />
      <section className="bg-brand-ink text-white">
        <div className="container-x py-14 md:py-16">
          <span className="label-eyebrow text-brand-purple">Contact</span>
          <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter md:text-5xl">Neem contact op</h1>
        </div>
      </section>

      <section className="container-x section-y grid gap-12 lg:grid-cols-[1fr_1.3fr]">
        <div>
          <h2 className="font-heading text-xl font-bold">Contactgegevens</h2>
          <div className="mt-5 space-y-4 text-zinc-700">
            <a href={`mailto:${c("contact_email", "bookings@voiceoverkids.agency")}`} className="flex items-center gap-3 hover:text-brand-violet"><span className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-100 text-brand-violet"><Mail size={18} /></span> {c("contact_email", "bookings@voiceoverkids.agency")}</a>
            <a href={`tel:${c("contact_phone", "+31 71 2032441").replace(/\s/g, "")}`} className="flex items-center gap-3 hover:text-brand-violet"><span className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-100 text-brand-violet"><Phone size={18} /></span> {c("contact_phone", "+31 71 2032441")}</a>
            <div className="flex items-start gap-3"><span className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-100 text-brand-violet"><MapPin size={18} /></span>
              <span className="whitespace-pre-line">{c("contact_address", "VoiceOverKids.Agency\nDe Savornin Lohmanplein 2\n2314 EV Leiden, Nederland")}<br /><span className="text-sm text-zinc-500">KVK 53824784 · BTW NL001977309B09</span></span>
            </div>
          </div>
          <div className="mt-8 rounded-2xl border border-zinc-200 bg-white p-5">
            <p className="text-sm text-zinc-600">Klaar om te casten? Sla het formulier over en stuur ons een volledige briefing.</p>
            <Link to="/casting" className="mt-3 inline-flex items-center gap-2 font-bold text-brand-violet">Start een casting <ArrowRight size={16} /></Link>
          </div>
        </div>

        <div>
          <h2 className="font-heading text-xl font-bold">Algemene vragen</h2>
          {formUrl ? (
            <div className="mt-5 overflow-hidden rounded-2xl border border-zinc-200 bg-white">
              <iframe
                title="Contactformulier"
                src={formUrl}
                data-testid="contact-form-embed"
                className="h-[900px] w-full"
                loading="lazy"
                allow="clipboard-write"
              />
            </div>
          ) : (
            <p className="mt-5 text-zinc-600">Mail ons op <a href="mailto:bookings@voiceoverkids.agency" className="font-semibold text-brand-violet">bookings@voiceoverkids.agency</a>.</p>
          )}
        </div>
      </section>
    </>
  );
}
